import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useKits = () => useQuery({ queryKey: [`kits`], queryFn: async () => {
    const callback = await API.get(`/store/kits`)
    return callback?.data
}})

export default useKits